import React, { useEffect, useState } from 'react'
import './website.css'
import { useNavigate, useParams } from 'react-router-dom'
import { WebsiteAgendamentoService } from '../services/api/WebsiteAgendamento/WebsiteAgendamentoService';
import { Col, Form, Row } from 'react-bootstrap';
import { dateBrToDb, dateDbToBr } from '../utils/Funcoes';
import AcordionServicos from './AcordionServicos';
import TemplateAgendamento from './TemplateAgendamento';
import BarraLogin from './componentes/BarraLogin';
import md5 from 'blueimp-md5';
import { useCookies } from 'react-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';


const WebAgendamento = () => {

  const { dominio } = useParams();


  const [empresaId, setEmpresaId] = useState(localStorage.getItem("company"));
  const [loading, setLoading] = useState(true)
  const [activePage, setActivePage] = useState(true)
  const [tiposServicos, setTiposServicos] = useState([])
  const [listHorarios, setListHorarios] = useState([])
  const [listProfissionais, setListProfissionais] = useState([])
  const [etapa, setEtapa] = useState(1)
  const [dadosAgendamento, setDadosAgendamento] = useState({
    servico: null,
    data: null,
    horario: null,
    profissional: null
  })

  const HASH_COOKIE = md5(dominio)
  const [cookies] = useCookies([HASH_COOKIE], { doNotParse: true });


  const navigate = useNavigate()





  const fetchTiposServicos = async (empresaId) => {
    const data = await WebsiteAgendamentoService.getTiposServicos(empresaId, {
      withServicosOnline: true,
      showServicos: true,
      withServicosProfVinculado: true
    });
    if (data.success) {
      setTiposServicos(data.data)
    }
  }

  const fetchBuscaHorarios = async (dataAg, servicosId) => {

    const data = await WebsiteAgendamentoService.getBuscaHorariosDisponiveis(empresaId, {
      data: dataAg,
      tipoBusca: 2,
      servicosId: servicosId
    });
    if (data.success) {
      console.log(data.data[0])
      if (data.data.length > 0) {
        if (data.data[0].horarios.length == 0) {
          setListHorarios([])
          setListProfissionais([])

        } else {
          setListHorarios(data.data)
        }
      }

      // setTiposServicos(data.data)
    }
  }





  const handleClickAgendar = (itemServico) => {
    let dataHoje = new Date().toISOString().split('T')[0]

    setEtapa(2)
    setDadosAgendamento({
      ...dadosAgendamento,
      servico: itemServico,
      data: (dataHoje),
      defaultData: dataHoje
    })

    fetchBuscaHorarios(dataHoje, itemServico.id)
  }

  const handleChange = (e) => {
    switch (e.target.name) {
      case 'data':
        setDadosAgendamento({
          ...dadosAgendamento,
          data: dateBrToDb(e.target.value)
        })
        fetchBuscaHorarios(dateBrToDb(e.target.value), dadosAgendamento.servico.id)
        break;
    }
  }

  const handleClickSelect = async (tipo, item) => {

    switch (tipo) {
      case 'horarios':
        setDadosAgendamento({
          ...dadosAgendamento,
          horario: item,
          profissional: null
        })
        setListProfissionais(item.profissionais)
        break;
      case 'profissional':
        setDadosAgendamento({
          ...dadosAgendamento,
          profissional: item
        })

        break;
      case 'confirmAgenda':
        setEtapa(3)
    
           console.log(cookies[HASH_COOKIE])
        if (cookies[HASH_COOKIE] != undefined) {


          let dadosAg = {
            empresaId: empresaId,
            data: dadosAgendamento.data,
            horario: dadosAgendamento.horario.hora,
            profissionalId: dadosAgendamento.profissional.id,
            servicosId: dadosAgendamento.servico.id
          }

          
       
          const resultAgenda = await WebsiteAgendamentoService.storeAgendamento(dadosAg)
        
         // cons
          if (resultAgenda.success) {
            navigate('/' + dominio + '/confirmAgendamento', { state: { dadosAgendamento } })
          } else {
            alert('')
          }

        } else {
          navigate('/' + dominio + '/login ', { state: { dadosAgendamento } })
        }

        break;
    }
  }
  const resetAgenda = () => {
    setDadosAgendamento({
      servico: null,
      data: null,
      horario: null,
      profissional: null
    })
    setEtapa(1)
    setListHorarios([])
    setListProfissionais([])
  }

  useEffect(() => {


    fetchTiposServicos(empresaId)
  }, [])

  {/*} if (loading) {
    return (<Container fluid className="d-flex  justify-content-center align-items-center min-vh-100" style={{ flexDirection: 'column' }}>
      <div style={{ fontSize: '16px', fontWeight: 500, color: '#40a788' }}>Carregando...</div>
      <br></br>
      <FontAwesomeIcon icon={faSpinner} spin className='fa-10x' style={{ color: "#63E6BE" }} />
    </Container>)

  }*/




    if (!activePage) {
      // return (<Page404 />)
    }
    // console.log(dadosAgendamento)

    return (
      <>

        <TemplateAgendamento>

          <div class="container">
            <div class="container agendamento-container">
              <h2 className=" mb-4 text-center mt-15 ">Agende seu atendimento

              </h2>
              <div style={{ display: (dadosAgendamento?.servico?.nome) ? '' : 'none' }}>
                <Row >
                  <Form.Group as={Col}>
                    <label>Serviço: </label> {dadosAgendamento?.servico?.nome}  <a href='#' onClick={() => resetAgenda()}>Alterar</a>
                  </Form.Group>
                </Row>
                <Row style={{ display: (dadosAgendamento?.data) ? '' : 'none' }}>
                  <Form.Group as={Col}>
                    <label>Data: </label> {(dadosAgendamento?.data) ? dateDbToBr(dadosAgendamento?.data) : ''}
                    {(dadosAgendamento?.horario?.hora) ? ' às ' + dadosAgendamento?.horario.hora + 'h' : ''}
                  </Form.Group>
                </Row>
                <Row style={{ display: (dadosAgendamento?.profissional) ? '' : 'none' }}>
                  <Form.Group as={Col}>
                    <label>Profissional: </label> {dadosAgendamento?.profissional?.nome}
                  </Form.Group>
                </Row>
              </div>
              {(etapa == 1) ? (
                <>
                  <h5 className='text-center'>Selecione um serviço</h5>
                  <AcordionServicos handleClickAgendar={handleClickAgendar} tiposServicos={tiposServicos} />
                </>
              ) : ''
              }


              {(etapa == 2) ? (
                <>
                  <hr></hr>
                  <h5>Selecione a data:</h5>
                  <div className="mb-4">
                    <input type="date" className="form-control" name='data' id="data" defaultValue={dadosAgendamento?.defaultData} required onChange={(e) => handleChange(e)} />
                  </div>


                  {(listHorarios?.length > 0) ? (

                    <>
                      <h5>Selecione um horário:</h5>
                      <div className="mb-4 horarios" id="horarios">
                        {listHorarios?.map((item) => (
                          <>
                            {item?.horarios?.map((itemHora) => (
                              <button type="button" className={(itemHora.hora == dadosAgendamento?.horario?.hora) ? "btn btn-primary" : "btn btn-outline-primary"} onClick={() => handleClickSelect('horarios', itemHora)}>{itemHora.hora}</button>
                            ))}

                          </>
                        ))}
                      </div>



                      {(listProfissionais.length > 0) ? <>
                        <h5>Escolha um profissional:</h5>


                        <div className="row g-3 mb-4" id="profissionais">
                          {(listProfissionais?.map((item) => (
                            <div className="col-6 col-md-3">
                              <div
                                onClick={() => handleClickSelect('profissional', item)}
                                className={(item.id == dadosAgendamento?.profissional?.id) ? "card profissional-card active text-center" : "card profissional-card text-center"} data-nome="João - Cabelereiro">
                                {/*}    <img src="https://via.placeholder.com/150" className="card-img-top" alt="João" />
                             */} <div className="card-body p-2">
                                  <h6 className="card-title" style={{ color: '#252525ff' }}>
                                    {(item.id == dadosAgendamento?.profissional?.id) ? <FontAwesomeIcon className='text-success mr-5' icon={faCheckCircle} /> : ''}
                                    {item.nome}</h6>
                                  {/*<p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>{item.nome}</p>*/}
                                </div>
                              </div>
                            </div>
                          )))}
                        </div>
                      </> : ''}


                      <button type="submit" className="btn btn-success w-100" onClick={() => handleClickSelect('confirmAgenda')}>Confirmar Agendamento</button>
                    </>
                  ) : <div className='alert alert-warning text-center'>Sem horários para esta data</div>}
                </>
              ) : ''
              }

              {(etapa == 3) ? (<>
                confirmar
              </>) : ''}

            </div >

          </div>

        </TemplateAgendamento>


      </>
    )


  }
}
export default WebAgendamento